export default {
  isMobile: state => state.isMobile,
  isSmallMobile: state => state.isSmallMobile,
  isExtraSmallMobile: state => state.isExtraSmallMobile,
  isAdhdFocusActive: state => state.isAdhdFocusActive
}
